import { render, staticRenderFns } from "./ProgressNotes.vue?vue&type=template&id=2f0f163f&scoped=true&"
import script from "./ProgressNotes.vue?vue&type=script&lang=js&"
export * from "./ProgressNotes.vue?vue&type=script&lang=js&"
import style0 from "./ProgressNotes.vue?vue&type=style&index=0&id=2f0f163f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f163f",
  null
  
)

export default component.exports